import { Effect, References } from "effect";
import { canonicalJsonDigest } from "../../canonical-json/digest.ts";
import { canonicalJsonCause } from "../../canonical-json/cause.ts";
import { changeReviewError, type ReviewManifestInput } from "./model.ts";
import { reviewManifestIdentity } from "./pure.ts";

/** The existing Digest graph owns hashing. Synchronous selection and an
 * accepted hash keep their snapshot and private refusal through interruption. */
export const createReviewManifest = Effect.fn("ChangeReview.createManifest")((input: ReviewManifestInput) =>
  Effect.gen(function* () {
    const identity = yield* Effect.fromResult(reviewManifestIdentity(input));
    const digest = yield* canonicalJsonDigest(identity).pipe(
      Effect.mapError(error => changeReviewError(canonicalJsonCause(error)))
    );
    return Object.freeze({ ...identity, manifestDigest: `sha256:${digest}` });
  }).pipe(
    Effect.catchDefect(cause => Effect.fail(changeReviewError(cause))),
    Effect.uninterruptible,
    Effect.provideService(References.PreventSchedulerYield, true)
  )
);
